import { useState, useEffect, useRef } from 'react'
import { Eye } from 'lucide-react'
import './VisitorCounter.css'

// Offset so displayed count starts at 5 000+.
// When real visits grow past ~1 000, set this to 0.
const BASE_COUNT = 5000

const VisitorCounter = () => {
  const [extra, setExtra] = useState(0)
  const called = useRef(false)

  useEffect(() => {
    if (called.current) return
    called.current = true
    fetch('https://api.counterapi.dev/v1/thangamariappan/portfolio-visits/up')
      .then(r => (r.ok ? r.json() : null))
      .then(d => { if (d?.count != null) setExtra(d.count) })
      .catch(() => {})
  }, [])

  return (
    <span className='visitor-counter' title='Total portfolio visits'>
      <Eye size={13} aria-hidden='true' />
      {(BASE_COUNT + extra).toLocaleString()}+ visitors
    </span>
  )
}

export default VisitorCounter
